var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.375h.75V5.5h-.75v2.875zM6 4.645a.39.39 0 0 0 .288-.117.39.39 0 0 0 .116-.288.39.39 0 0 0-.116-.287A.391.391 0 0 0 6 3.837a.391.391 0 0 0-.288.116.39.39 0 0 0-.116.287c0 .115.039.21.116.288A.39.39 0 0 0 6 4.644zm0 6.105a4.628 4.628 0 0 1-1.852-.374A4.797 4.797 0 0 1 2.64 9.361a4.797 4.797 0 0 1-1.016-1.508 4.623 4.623 0 0 1-.374-1.852c0-.657.125-1.275.374-1.853.25-.578.588-1.08 1.015-1.508.428-.428.93-.766 1.508-1.016a4.623 4.623 0 0 1 1.852-.374c.657 0 1.275.125 1.853.374.578.25 1.08.588 1.508 1.015.428.428.766.93 1.016 1.508s.374 1.195.374 1.852-.125 1.275-.374 1.853A4.797 4.797 0 0 1 9.361 9.36c-.428.428-.93.766-1.508 1.016a4.623 4.623 0 0 1-1.852.374zM6 10c1.117 0 2.063-.387 2.838-1.162C9.613 8.063 10 7.117 10 6s-.387-2.063-1.162-2.837C8.063 2.388 7.117 2 6 2s-2.063.388-2.837 1.163C2.388 3.938 2 4.883 2 6c0 1.117.388 2.063 1.163 2.838C3.938 9.613 4.883 10 6 10z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallInfoIcon);
export default __webpack_public_path__ + "static/media/small-info-icon.a3559446efe88537686919cab68abe0f.svg";
export { ForwardRef as ReactComponent };